// import {
//   requestBannerList,
// } from '@/api/banner';

const state = {
  bannerMode: null,
  bannerList: null,
};

const getters = {
  bannerMode: (state) => state.bannerMode,
  bannerList: (state) => state.bannerList,
};

const actions = {
  // async getBannerList({ commit, dispatch }) {
  //   await dispatch('setIsLoading', true, { root: true });
  //   const result = await requestBannerList();
  //   commit('getBannerList', result.data);
  //   await dispatch('setIsLoading', false, { root: true });
  // },
  async getBannerList({ commit }, { path, isJP = true }) {
    // await dispatch('setIsLoading', true, { root: true });
    // const result = await requestBannerList();
    const baseUrl = window.location.origin;
    let result;
    if (path.startsWith('/store')) {
      if (isJP) {
      // /store 専用バナー（言語別URL対応）
        result = {
          list: [
            {
              file_name: '/img/banner/store_banner_jp.png?v=2',
              sp_file_name: '/img/banner/store_banner_jp.png?v=2',
            },
          ],
        };
      } else {
        result = {
          list: [
            {
              file_name: '/img/banner/store_banner_en.png?v=1',
              sp_file_name: '/img/banner/store_banner_en.png?v=1',
            },
          ],
        };
      }
    } else if (path.startsWith('/market')) {
      if (isJP) {
        result = {
          list: [
            {
              file_name: '/img/banner/xmarket_jp.jpg?v=1',
              sp_file_name: '/img/banner/xmarket_jp.jpg?v=1',
              urls: {
                ja: [
                  'https://gtchax0218.zendesk.com/hc/ja/articles/4679257464862-Xmarket%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6',
                ],
              },
            },
          ],
        };
      } else {
        result = {
          list: [
            {
              file_name: '/img/banner/xmarket_en.jpg?v=1',
              sp_file_name: '/img/banner/xmarket_en.jpg?v=1',
              urls: {
                en: [
                  'https://gtchax0218.zendesk.com/hc/en-us/articles/4679257464862-About-Xmarket',
                ],
                it: [
                  'https://gtchax0218.zendesk.com/hc/it/articles/4679257464862-Informazioni-su-Xmarket',
                ],
                de: [
                  'https://gtchax0218.zendesk.com/hc/de/articles/4679257464862-%C3%9Cber-Xmarket',
                ],
                es: [
                  'https://gtchax0218.zendesk.com/hc/en-us/articles/4679257464862-About-Xmarket',
                ],
                fr: [
                  'https://gtchax0218.zendesk.com/hc/fr/articles/4679257464862-%C3%80-propos-de-Xmarket',
                ],
                ko: [
                  'https://gtchax0218.zendesk.com/hc/ko/articles/4679257464862-Xmarket%EC%97%90-%EB%8C%80%ED%95%B4',
                ],
                zh: [
                  'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4679257464862-%E5%85%B3%E4%BA%8EXmarket',
                ],
                'zh-TW': [
                  'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4679257464862-%E9%97%9C%E6%96%BC-Xmarket',
                ],
              },
            },
          ],
        };
      }
    } else if (isJP) {
      // 通常バナー（日本語）
      // result = {
      //   list: [
      //     {
      //       file_name: '/img/banner/pc01.jpg?v=1',
      //       sp_file_name: '/img/banner/sp01.jpg?v=2',
      //     },
      //   ],
      // };
      result = {
        list: [
          {
            file_name: [
              // 1枚目固定バナー↓
              '/img/banner/top_banner_jp.png?v=1',
              // Xmarketについて↓
              '/img/banner/banner_jp1.png?v=1',
              // 友達招待↓
              '/img/banner/banner_jp_friend.png?v=1',
              // 郵送買取受付中↓
              '/img/banner/banner_jp3.png?v=1',
            ],
            sp_file_name: [
              '/img/banner/top_banner_jp.png?v=1',
              '/img/banner/banner_jp1.png?v=2',
              '/img/banner/banner_jp_friend.png?v=2',
              '/img/banner/banner_jp3.png?v=2',
            ],
            urls: {
              ja: [
                null,
                'https://gtchax0218.zendesk.com/hc/ja/articles/4679257464862-Xmarket%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6',
                'https://gtchax0218.zendesk.com/hc/ja/articles/4704693600414-%E5%8F%8B%E9%81%94%E7%B4%B9%E4%BB%8B%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6',
                `${baseUrl}/purchase-card`,
              ],
            },
          },
        ],
      };
    } else {
      // 通常バナー（多言語）
      result = {
        list: [
          {
            file_name: [
              // 1枚目固定バナー↓
              '/img/banner/top_banner_en.png?v=1',
              // Xmarketについて↓
              '/img/banner/banner_en1.png?v=1',
              // PSAについて↓
              '/img/banner/banner_en2.png?v=1',
              // 年末大抽選↓
              '/img/banner/banner_en3.png?v=1',
              // 友達招待↓
              '/img/banner/banner_en4.png?v=1',
            ],
            sp_file_name: [
              '/img/banner/top_banner_en.png?v=1',
              '/img/banner/banner_en1.png?v=2',
              '/img/banner/banner_en2.png?v=2',
              '/img/banner/banner_en3.png?v=2',
              '/img/banner/banner_en4.png?v=2',
            ],
            urls: {
              en: [
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4979055149982-What-s-this-site-about',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4679257464862-About-Xmarket',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4974849633438-PSA-option',
                // 'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4704693600414-About-introducing-friends',
              ],
              it: [
                'https://gtchax0218.zendesk.com/hc/it/articles/4979055149982-Di-cosa-tratta-questo-sito',
                'https://gtchax0218.zendesk.com/hc/it/articles/4679257464862-Informazioni-su-Xmarket',
                'https://gtchax0218.zendesk.com/hc/it/articles/4974849633438-Opzione-PSA',
                // 'https://gtchax0218.zendesk.com/hc/it/articles/4966172545694-Grande-lotteria-di-fine-anno',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/it/articles/4704693600414-Informazioni-sull-invito-di-amici',
              ],
              de: [
                'https://gtchax0218.zendesk.com/hc/de/articles/4979055149982-Worum-geht-es-auf-dieser-Website',
                'https://gtchax0218.zendesk.com/hc/de/articles/4679257464862-%C3%9Cber-Xmarket',
                'https://gtchax0218.zendesk.com/hc/de/articles/4974849633438-PSA-Option',
                // 'https://gtchax0218.zendesk.com/hc/de/articles/4966172545694-Gro%C3%9Fe-Jahresendverlosung',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/de/articles/4704693600414-Freunde-einladen',
              ],
              es: [
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4979055149982-What-s-this-site-about',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4679257464862-About-Xmarket',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4974849633438-PSA-option',
                // 'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4704693600414-About-introducing-friends',
              ],
              fr: [
                'https://gtchax0218.zendesk.com/hc/fr/articles/4979055149982-De-quoi-traite-ce-site',
                'https://gtchax0218.zendesk.com/hc/fr/articles/4679257464862-%C3%80-propos-de-Xmarket',
                'https://gtchax0218.zendesk.com/hc/fr/articles/4974849633438-Option-PSA',
                // 'https://gtchax0218.zendesk.com/hc/fr/articles/4966172545694-Grande-loterie-de-fin-d-ann%C3%A9e',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/fr/articles/4704693600414-%C3%80-propos-de-la-pr%C3%A9sentation-d-amis',
              ],
              ko: [
                'https://gtchax0218.zendesk.com/hc/ko/articles/4979055149982-%EC%9D%B4-%EC%82%AC%EC%9D%B4%ED%8A%B8%EB%8A%94-%EB%AC%B4%EC%97%87%EC%9D%B8%EA%B0%80%EC%9A%94',
                'https://gtchax0218.zendesk.com/hc/ko/articles/4679257464862-Xmarket%EC%97%90-%EB%8C%80%ED%95%B4',
                'https://gtchax0218.zendesk.com/hc/ko/articles/4974849633438-PSA-%EC%98%B5%EC%85%98',
                // 'https://gtchax0218.zendesk.com/hc/ko/articles/4966172545694-%EC%97%B0%EB%A7%90-%EB%8C%80%EC%B6%94%EC%B2%A8',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/ko/articles/4704693600414-%EC%B9%9C%EA%B5%AC-%EC%86%8C%EA%B0%9C%EC%97%90-%EB%8C%80%ED%95%B4',

              ],
              zh: [
                'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4979055149982-%E6%9C%AC%E7%BD%91%E7%AB%99%E6%98%AF%E5%81%9A%E4%BB%80%E4%B9%88%E7%9A%84',
                'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4679257464862-%E5%85%B3%E4%BA%8EXmarket-%E5%8D%B3%E5%B0%86%E6%8E%A8%E5%87%BA',
                'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4974849633438-PSA%E8%AF%84%E7%BA%A7%E6%9C%8D%E5%8A%A1',
                // 'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4966172545694-%E5%B9%B4%E6%9C%AB%E5%A4%A7%E6%8A%BD%E5%A5%96',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4704693600414-%E5%85%B3%E4%BA%8E%E4%BB%8B%E7%BB%8D%E6%9C%8B%E5%8F%8B',
              ],
              'zh-TW': [
                'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4979055149982-%E9%80%99%E5%80%8B%E7%B6%B2%E7%AB%99%E6%98%AF%E5%81%9A%E4%BB%80%E9%BA%BC%E7%9A%84',
                'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4679257464862-%E9%97%9C%E6%96%BC-Xmarket',
                'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4974849633438-PSA%E9%81%B8%E9%A0%85',
                // 'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4966172545694-%E5%B9%B4%E6%9C%AB%E5%A4%A7%E6%8A%BD%E7%8D%8E',
                'https://gtchax0218.zendesk.com/hc/en-us/articles/4966172545694-Year-End-Grand-Lottery',
                'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4704693600414-%E9%97%9C%E6%96%BC%E6%8E%A8%E8%96%A6%E6%9C%8B%E5%8F%8B',
              ],
            },
          },
        ],
      };
    }
    commit('getBannerList', result);
    // await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  getBannerList(state, bannerList) {
    state.bannerList = bannerList;
    state.bannerMode = bannerList.mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
